import { render } from "./Element.vue?vue&type=template&id=d66b6594&scoped=true&ts=true"
import script from "./Element.vue?vue&type=script&lang=ts"
export * from "./Element.vue?vue&type=script&lang=ts"

import "./Element.vue?vue&type=style&index=0&id=d66b6594&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66b6594"]])

export default __exports__